import { SolutionPageTemplate } from "@/components/solutions/SolutionPageTemplate";
import { Truck, MapPinOff, Clock, RotateCcw, Map, ShieldCheck, BarChart3 } from "lucide-react";

const challenges = [
  {
    titleKey: "solutionPages.transport.challenges.items.zones.title",
    descriptionKey: "solutionPages.transport.challenges.items.zones.description",
    icon: MapPinOff,
  },
  {
    titleKey: "solutionPages.transport.challenges.items.routes.title",
    descriptionKey: "solutionPages.transport.challenges.items.routes.description",
    icon: Clock,
  },
  {
    titleKey: "solutionPages.transport.challenges.items.returns.title",
    descriptionKey: "solutionPages.transport.challenges.items.returns.description",
    icon: RotateCcw,
  },
];

const solutions = [
  {
    titleKey: "solutionPages.transport.solutions.items.areas.title",
    descriptionKey: "solutionPages.transport.solutions.items.areas.description",
    icon: Map,
  },
  {
    titleKey: "solutionPages.transport.solutions.items.data.title",
    descriptionKey: "solutionPages.transport.solutions.items.data.description",
    icon: ShieldCheck,
  },
  {
    titleKey: "solutionPages.transport.solutions.items.optimize.title",
    descriptionKey: "solutionPages.transport.solutions.items.optimize.description",
    icon: BarChart3,
  },
];

const relevantProducts = [
  {
    nameKey: "solutionPages.transport.products.items.atlas.name",
    descriptionKey: "solutionPages.transport.products.items.atlas.description",
    href: "/tjanster/atlas",
    icon: Map,
  },
  {
    nameKey: "solutionPages.transport.products.items.valid.name",
    descriptionKey: "solutionPages.transport.products.items.valid.description",
    href: "/tjanster/valid",
    icon: ShieldCheck,
  },
  {
    nameKey: "solutionPages.transport.products.items.adresstwatt.name",
    descriptionKey: "solutionPages.transport.products.items.adresstwatt.description",
    href: "/tjanster/adresstwatt",
    icon: BarChart3,
  },
];

const heroHighlights = [
  "Definiera och visualisera leveranszoner med postnummerprecision i Atlas",
  "Validera alla adresser innan avsändning med Valid",
  "Håll ert kundregister rent med Adresstvätt",
];

const productBullets: Record<string, string[]> = {
  atlas: [
    "Bygg leveranszoner med postnummerytor som byggstenar",
    "Visualisera och analysera områden per terminal, chaufför eller region",
  ],
  valid: [
    "Validera leveransadresser i realtid innan paketet lämnar terminalen",
    "Fånga felaktiga och ofullständiga adresser direkt vid inmatning",
  ],
  adresstwatt: [
    "Tvätta kundregister regelbundet för korrekt adressdata",
    "Identifiera och korrigera inaktuella adresser automatiskt",
  ],
};

const TransportPage = () => {
  return (
    <SolutionPageTemplate
      solutionKey="transport"
      heroIcon={Truck}
      challenges={challenges}
      solutions={solutions}
      relevantProducts={relevantProducts}
      heroHighlights={heroHighlights}
      challengeImpactKey="Felaktiga adresser och oklara leveranszoner kostar transportbolag miljontals kronor årligen i returer, bomkörningar och förseningar."
      productBullets={productBullets}
    />
  );
};

export default TransportPage;
